<template>
  <div :class="`user-icon ${status}`">
    <span class="icon"></span>
  </div>
</template>

<script>
  export default {
    name: "StatusGroupIcon",
    props: {
      status: {
        type: String,
        default: "is-inactive"
      }
    }
  }
</script>